export enum MessageTypeEnum {
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
  SUCCESS = "success",
}
